export default __webpack_public_path__ + "static/media/n.b1df10b6.svg";